import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const stored = localStorage.getItem('cookie_consent');
    if (!stored) {
      // Slight delay so the banner doesn't compete with first paint
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem('cookie_consent', value); } catch (_) { /* noop */ }
    setShow(false);
  };

  // Never render on /admin — the banner (fixed bottom-left, z-100) was
  // overlaying the admin sidebar and intercepting clicks on Settings /
  // lower-nav tabs for fresh admin sessions. Admins have their own auth,
  // don't need a public consent modal.
  if (!show || location.pathname.startsWith('/admin')) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-md z-[100] animate-fade-in"
    >
      <div className="bg-[#0A0A0A]/95 backdrop-blur-md border border-[#D4AF37]/30 p-5 shadow-2xl">
        <div className="flex items-start gap-3 mb-3">
          <Cookie className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-white text-sm font-medium font-sans mb-1">We value your privacy</h3>
            <p className="text-white/60 text-xs leading-relaxed font-sans">
              We use cookies to enhance your experience and gather anonymous analytics so we can keep
              improving JS Fragrance. Read our{' '}
              <Link to="/privacy" className="text-[#D4AF37] hover:text-white underline">Privacy Policy</Link>.
            </p>
          </div>
          <button
            onClick={() => decide('declined')}
            data-testid="cookie-consent-close"
            className="text-white/40 hover:text-white transition-colors flex-shrink-0"
            aria-label="Decline cookies"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => decide('declined')}
            data-testid="cookie-consent-decline"
            className="flex-1 px-4 py-2 text-[11px] uppercase tracking-[0.2em] font-sans border border-white/20 text-white/70 hover:border-white/40 hover:text-white transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => decide('accepted')}
            data-testid="cookie-consent-accept"
            className="flex-1 px-4 py-2 text-[11px] uppercase tracking-[0.2em] font-sans bg-[#1C7D3F] text-white hover:bg-[#2E9B50] transition-colors font-medium"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
